export const possibleRooms = [1, 2, 3, 4, 5];
